<div class="configuration-area-downloads">
  <div class="tabs-container">
    <tpm-tabs
      class="child-tabs"
      [child]="true"
      [tabs]="tabs"
      [active]="(currentTab$ | async)?.name"
      (activeTabChange)="onModuleChange($any($event))"
    ></tpm-tabs>
  </div>
  <div *ngIf="vm$ | async as vm" class="configuration-area-downloads__card">
    <p class="headline-3 heading">
      {{ "CONFIGURATION_AREA.DOWNLOADS.HEADLINE" | translate }} {{ (currentTab$ | async)?.label | translate }}
      <a class="grafana-link" [href]="grafanaUrl$ | async" target="_blank">
        {{ "CONFIGURATION_AREA.DOWNLOADS.GRAFANA_LINK" | translate }}
      </a>
    </p>
    <button
      ene-filled-button
      size="xlarge"
      icon="ec_check"
      [disabled]="!vm.hasMulti"
      (click)="downloadArchive(vm.module)"
    >
      {{ "CONFIGURATION_AREA.DOWNLOADS.DOWNLOAD_ARCHIVE" | translate }}
    </button>
    <ngmy-table
      class="configuration-area-downloads__table"
      selections
      [hideFilter]="true"
      [disableSort]="false"
      [sortActive]="'timestamp'"
      [sortDirection]="'desc'"
      [pagingConfig]="pagingConfig"
      [columnsConfig]="columnsConfig"
      [loading]="vm.loading"
      [data]="vm.result"
      (tableAction)="onTableAction(vm.module, $event)"
    ></ngmy-table>
  </div>
</div>
